import { useState } from 'react'
import { TextField, Select } from '@cinesend/ui-kit'
import { formatFileSize, convertToBytes } from '../../helpers/human_file_size'

const AirlineSnapshotSizeInput = ({ fieldName, value, label, saveModel }) => {
  const maxTotalSnapshotSize = formatFileSize(value)
  const [maxTotalSnapshotSizeState, setMaxTotalSnapshotSizeState] = useState({
    size: maxTotalSnapshotSize?.size || 0,
    unit: maxTotalSnapshotSize?.unit || 'MB',
  })
  const updateState = (newState) => {
    const updatedState = { ...maxTotalSnapshotSizeState, ...newState }
    const bytes = convertToBytes(updatedState.size, updatedState.unit)

    setMaxTotalSnapshotSizeState(updatedState)

    saveModel({ [fieldName]: bytes })
  }
  const units = ['KB', 'MB', 'GB', 'TB'].map((unit) => ({ label: unit, value: unit }))
  return (
    <div className='flex items-end space-x-2'>
      <TextField
        type='number'
        label={label}
        value={maxTotalSnapshotSizeState.size}
        onChange={(e) => {
          setMaxTotalSnapshotSizeState({
            size: e.target.value,
            unit: maxTotalSnapshotSizeState.unit,
          })
        }}
        onBlur={() => updateState({ size: maxTotalSnapshotSizeState.size })}
      />
      <Select
        label='Unit'
        hideLabel
        options={units}
        value={maxTotalSnapshotSizeState.unit}
        onValueChange={(unit) => {
          updateState({ unit })
        }}
      />
    </div>
  )
}

export default AirlineSnapshotSizeInput
